export const COMPANY = {
  name: "Nicobrand S.R.L.",
  brand: "ClarWash",
  cui: "51705790",
  regCom: "J2025030277002",
  phone: "0750 295 264",
  email: "cosmindanuu@gmail.com",
  address: "Aleea Ștrandului, Tecuci, jud. Galați, România",
};

const UPDATED = "iunie 2026";

export const LEGAL_PAGES = {
  "termeni-si-conditii": {
    title: "Termeni și Condiții",
    updated: UPDATED,
    intro: `Vă rugăm să citiți cu atenție acești Termeni și Condiții înainte de a utiliza magazinul online ${COMPANY.brand} (denumit în continuare „Site-ul"). Prin plasarea unei comenzi, confirmați că ați citit, ați înțeles și acceptați în întregime prezentele condiții.`,
    sections: [
      {
        heading: "1. Informații despre vânzător",
        body: [
          `Magazinul online ${COMPANY.brand} este operat de ${COMPANY.name}, cu sediul în ${COMPANY.address}, cod unic de înregistrare (CUI) ${COMPANY.cui}, număr de ordine în Registrul Comerțului ${COMPANY.regCom}.`,
          { list: [
            `Telefon: ${COMPANY.phone}`,
            `E-mail: ${COMPANY.email}`,
            `Adresă: ${COMPANY.address}`,
            `CUI: ${COMPANY.cui}`,
            `Nr. Reg. Com.: ${COMPANY.regCom}`,
          ] },
        ],
      },
      {
        heading: "2. Definiții",
        body: [
          { list: [
            "Vânzător – societatea menționată mai sus, care comercializează produsele prezentate pe Site.",
            "Cumpărător / Client – orice persoană fizică (peste 18 ani) sau juridică care plasează o comandă pe Site.",
            "Produse – detergenții, balsamurile de rufe și pachetele promoționale afișate pe Site.",
            "Comandă – solicitarea fermă transmisă de Client pentru achiziționarea unuia sau mai multor Produse.",
          ] },
        ],
      },
      {
        heading: "3. Produse, prețuri și disponibilitate",
        body: [
          "Toate prețurile afișate pe Site sunt exprimate în lei (RON) și includ TVA, conform legislației fiscale în vigoare.",
          "Transportul este GRATUIT la toate comenzile, pe întreg teritoriul României.",
          "Ne rezervăm dreptul de a modifica prețurile și disponibilitatea produselor fără notificare prealabilă. Prețul valabil este cel afișat în momentul plasării comenzii.",
          "Imaginile produselor au caracter informativ și pot diferi ușor de aspectul real (ambalaj, etichetă).",
        ],
      },
      {
        heading: "4. Plasarea comenzii și încheierea contractului",
        body: [
          "Comanda poate fi plasată direct pe Site, telefonic sau prin WhatsApp la numărul afișat.",
          "Contractul de vânzare se consideră încheiat în momentul în care Clientul primește confirmarea comenzii din partea Vânzătorului (telefonic, prin e-mail sau WhatsApp).",
          "Vânzătorul își rezervă dreptul de a anula o comandă în caz de indisponibilitate a produsului sau date de contact incorecte, cu informarea prealabilă a Clientului.",
        ],
      },
      {
        heading: "5. Modalități de plată",
        body: [
          "Plata se efectuează exclusiv prin ramburs la livrare (numerar sau card la curier, în funcție de opțiunile curierului).",
          "Nu procesăm plăți online pe Site și nu solicităm niciodată date de card pe pagina noastră.",
        ],
      },
      {
        heading: "6. Livrare",
        body: [
          "Livrarea se face prin curier rapid, pe întreg teritoriul României.",
          "Termenul estimativ de livrare este de 1–5 zile lucrătoare de la confirmarea comenzii.",
          "Transportul este gratuit, indiferent de valoarea comenzii. Detalii suplimentare în Politica de livrare.",
        ],
      },
      {
        heading: "7. Dreptul de retragere",
        body: [
          "Conform O.U.G. nr. 34/2014, Clientul persoană fizică are dreptul de a se retrage din contract în termen de 14 zile calendaristice, fără a fi nevoit să justifice decizia.",
          "Detalii complete privind procedura, excepțiile și rambursarea sumelor sunt disponibile în Politica de retur.",
        ],
      },
      {
        heading: "8. Garanții și conformitate",
        body: [
          "Produsele beneficiază de garanția legală de conformitate conform O.U.G. nr. 140/2021.",
          "În cazul unui produs neconform, Clientul are dreptul la remedierea situației (înlocuire sau restituirea contravalorii), conform legii.",
        ],
      },
      {
        heading: "9. Limitarea răspunderii",
        body: [
          "Vânzătorul nu răspunde pentru utilizarea necorespunzătoare a produselor, contrar instrucțiunilor de pe ambalaj.",
          "Vânzătorul nu poate fi ținut răspunzător pentru întârzieri sau imposibilitate de executare cauzate de forță majoră.",
        ],
      },
      {
        heading: "10. Protecția datelor cu caracter personal",
        body: [
          "Prelucrăm datele personale ale Clienților în conformitate cu Regulamentul (UE) 2016/679 (GDPR). Detalii în Politica de confidențialitate.",
        ],
      },
      {
        heading: "11. Soluționarea litigiilor",
        body: [
          "Orice litigiu se soluționează pe cale amiabilă. În caz contrar, Clientul se poate adresa Autorității Naționale pentru Protecția Consumatorilor (ANPC).",
          "Consumatorii au acces la mecanismele de Soluționare Alternativă a Litigiilor (SAL) și la platforma europeană de Soluționare Online a Litigiilor (SOL). Linkurile sunt disponibile în subsolul site-ului.",
          "Legea aplicabilă este legea română.",
        ],
      },
      {
        heading: "12. Modificarea termenilor",
        body: [
          "Vânzătorul își rezervă dreptul de a modifica prezenții Termeni și Condiții. Versiunea aplicabilă este cea publicată pe Site la momentul plasării comenzii.",
        ],
      },
    ],
  },

  "confidentialitate": {
    title: "Politica de Confidențialitate (GDPR)",
    updated: UPDATED,
    intro: `${COMPANY.name} respectă confidențialitatea datelor dumneavoastră și prelucrează datele cu caracter personal în conformitate cu Regulamentul (UE) 2016/679 (GDPR) și legislația națională aplicabilă.`,
    sections: [
      {
        heading: "1. Operatorul de date",
        body: [
          `Operatorul datelor cu caracter personal este ${COMPANY.name}, CUI ${COMPANY.cui}, cu sediul în ${COMPANY.address}.`,
          `Ne puteți contacta pentru orice aspect legat de protecția datelor la e-mail: ${COMPANY.email} sau telefon: ${COMPANY.phone}.`,
        ],
      },
      {
        heading: "2. Ce date colectăm",
        body: [
          { list: [
            "Nume și prenume",
            "Număr de telefon",
            "Adresă de e-mail",
            "Adresă de livrare",
            "Detaliile comenzilor plasate",
          ] },
          "Nu colectăm și nu stocăm date privind cardurile bancare, întrucât plata se face exclusiv prin ramburs la livrare.",
        ],
      },
      {
        heading: "3. Scopurile și temeiul prelucrării",
        body: [
          { list: [
            "Procesarea și livrarea comenzilor (executarea contractului).",
            "Contactarea Clientului pentru confirmarea comenzii (executarea contractului).",
            "Îndeplinirea obligațiilor legale, fiscale și contabile (obligație legală).",
            "Răspunsul la solicitările transmise prin formularul de contact (interes legitim).",
          ] },
        ],
      },
      {
        heading: "4. Destinatarii datelor",
        body: [
          "Datele pot fi transmise firmelor de curierat pentru livrarea comenzilor și furnizorilor de servicii IT/e-mail utilizați pentru transmiterea notificărilor de comandă. Acești parteneri prelucrează datele exclusiv conform instrucțiunilor noastre.",
          "Nu vindem și nu închiriem datele dumneavoastră către terți.",
        ],
      },
      {
        heading: "5. Durata de stocare",
        body: [
          "Păstrăm datele pe durata necesară îndeplinirii scopurilor pentru care au fost colectate și pe perioada impusă de obligațiile legale (ex. documente contabile).",
        ],
      },
      {
        heading: "6. Drepturile dumneavoastră",
        body: [
          "În calitate de persoană vizată, aveți următoarele drepturi:",
          { list: [
            "Dreptul de acces la date",
            "Dreptul la rectificare",
            "Dreptul la ștergere (dreptul de a fi uitat)",
            "Dreptul la restricționarea prelucrării",
            "Dreptul la portabilitatea datelor",
            "Dreptul de opoziție",
            "Dreptul de a nu face obiectul unei decizii automatizate",
          ] },
          `Pentru exercitarea acestor drepturi, ne puteți contacta la ${COMPANY.email}.`,
        ],
      },
      {
        heading: "7. Securitatea datelor",
        body: [
          "Aplicăm măsuri tehnice și organizatorice adecvate pentru protejarea datelor împotriva accesului neautorizat, pierderii sau distrugerii.",
        ],
      },
      {
        heading: "8. Cookie-uri",
        body: [
          "Site-ul utilizează cookie-uri. Detalii în Politica de cookie-uri.",
        ],
      },
      {
        heading: "9. Reclamații",
        body: [
          "Dacă apreciați că v-au fost încălcate drepturile, vă puteți adresa Autorității Naționale de Supraveghere a Prelucrării Datelor cu Caracter Personal (ANSPDCP), www.dataprotection.ro.",
        ],
      },
    ],
  },

  "politica-cookies": {
    title: "Politica de Cookie-uri",
    updated: UPDATED,
    intro: "Această politică explică modul în care folosim cookie-urile și tehnologiile similare pe site-ul nostru.",
    sections: [
      {
        heading: "1. Ce sunt cookie-urile",
        body: [
          "Cookie-urile sunt fișiere text de mici dimensiuni stocate pe dispozitivul dumneavoastră (calculator, telefon, tabletă) atunci când vizitați un site web. Ele ajută site-ul să funcționeze corect și să rețină anumite preferințe.",
        ],
      },
      {
        heading: "2. Tipuri de cookie-uri utilizate",
        body: [
          { list: [
            "Cookie-uri strict necesare – asigură funcționarea de bază a site-ului (ex. coșul de cumpărături, sesiunea de autentificare). Acestea nu pot fi dezactivate.",
            "Cookie-uri funcționale – rețin preferințele dumneavoastră pentru o experiență mai bună.",
          ] },
          "Nu folosim cookie-uri de publicitate care să creeze profiluri de marketing.",
        ],
      },
      {
        heading: "3. Gestionarea cookie-urilor",
        body: [
          "Puteți controla și șterge cookie-urile din setările browserului dumneavoastră. Dezactivarea anumitor cookie-uri poate afecta funcționarea site-ului (ex. coșul de cumpărături).",
        ],
      },
      {
        heading: "4. Consimțământ",
        body: [
          "Prin continuarea navigării pe site, sunteți de acord cu utilizarea cookie-urilor strict necesare și funcționale, conform prezentei politici.",
        ],
      },
    ],
  },

  "politica-retur": {
    title: "Politica de Retur și Dreptul de Retragere",
    updated: UPDATED,
    intro: "Vă oferim posibilitatea de a returna produsele conform legislației în vigoare privind protecția consumatorilor.",
    sections: [
      {
        heading: "1. Dreptul legal de retragere (14 zile)",
        body: [
          "Conform O.U.G. nr. 34/2014, în calitate de consumator persoană fizică, aveți dreptul de a vă retrage din contract în termen de 14 zile calendaristice de la primirea produsului, fără penalități și fără a fi nevoit să justificați decizia.",
        ],
      },
      {
        heading: "2. Cum returnați un produs",
        body: [
          "Pentru a exercita dreptul de retragere, ne puteți notifica printr-o declarație clară:",
          { list: [
            `Telefon: ${COMPANY.phone}`,
            `E-mail: ${COMPANY.email}`,
          ] },
          "Vă rugăm să includeți numărul comenzii, produsul returnat și datele dumneavoastră de contact.",
        ],
      },
      {
        heading: "3. Starea produselor returnate",
        body: [
          "Produsele trebuie returnate în starea în care au fost primite, nedeteriorate.",
          "Conform legii, dreptul de retragere nu se aplică produselor sigilate care nu pot fi returnate din motive de protecție a sănătății sau igienă și care au fost desigilate după livrare.",
        ],
      },
      {
        heading: "4. Rambursarea sumelor",
        body: [
          "Vom rambursa contravaloarea produselor returnate în termen de maximum 14 zile de la data la care am fost informați cu privire la decizia de retragere.",
          "Rambursarea se efectuează prin metoda agreată împreună cu Clientul (transfer bancar).",
        ],
      },
      {
        heading: "5. Model de formular de retragere",
        body: [
          "Puteți utiliza următorul model (opțional):",
          `„Către ${COMPANY.name}: Vă informez prin prezenta cu privire la retragerea mea din contractul de vânzare a următoarelor produse [.....], comandate la data de [.....]. Numele consumatorului: [.....]. Data: [.....]."`,
        ],
      },
    ],
  },

  "politica-livrare": {
    title: "Politica de Livrare",
    updated: UPDATED,
    intro: "Livrăm produsele ClarWash rapid și în siguranță, cu transport GRATUIT pe întreg teritoriul României.",
    sections: [
      {
        heading: "1. Zona de livrare",
        body: [
          "Livrăm pe întreg teritoriul României, prin firme de curierat rapid.",
        ],
      },
      {
        heading: "2. Termen de livrare",
        body: [
          "Termenul estimativ de livrare este de 1–5 zile lucrătoare de la confirmarea comenzii.",
          "Termenele pot varia în perioadele aglomerate (sărbători) sau din cauze independente de voința noastră.",
        ],
      },
      {
        heading: "3. Costul livrării",
        body: [
          "Transportul este GRATUIT la toate comenzile, indiferent de valoarea acestora.",
        ],
      },
      {
        heading: "4. Plata",
        body: [
          "Plata se face prin ramburs la livrare (numerar sau card la curier). Verificați coletul la primire.",
        ],
      },
    ],
  },

  "protectia-consumatorului": {
    title: "Protecția Consumatorului (ANPC)",
    updated: UPDATED,
    intro: "Drepturile consumatorilor sunt protejate conform legislației române și europene. Mai jos găsiți informațiile și instrumentele puse la dispoziție de ANPC.",
    sections: [
      {
        heading: "1. Autoritatea Națională pentru Protecția Consumatorilor",
        body: [
          "ANPC este autoritatea competentă în domeniul protecției consumatorilor din România.",
          { list: [
            "Website: anpc.ro",
            "Telefon consumatori (InfoCons / call center ANPC): 021.9551",
          ] },
        ],
      },
      {
        heading: "2. Soluționarea Alternativă a Litigiilor (SAL)",
        body: [
          "Dacă aveți o problemă cu o comandă și nu ați reușit să o soluționați direct cu noi, vă puteți adresa entităților de Soluționare Alternativă a Litigiilor (SAL).",
          "Accesați: https://anpc.ro/ce-este-sal/",
        ],
      },
      {
        heading: "3. Soluționarea Online a Litigiilor (SOL / ODR)",
        body: [
          "Comisia Europeană pune la dispoziția consumatorilor platforma de Soluționare Online a Litigiilor (SOL).",
          "Accesați: https://ec.europa.eu/consumers/odr",
        ],
      },
      {
        heading: "4. Bannere oficiale ANPC",
        body: [
          "Cele două pictograme oficiale SAL și SOL sunt afișate în subsolul (footer) fiecărei pagini a site-ului, conform Ordinului ANPC nr. 449/2022.",
        ],
      },
    ],
  },
};
